import type React from 'react';
import type { Props } from './interface';
import { Helmet } from 'react-helmet-async';

const SEO: React.FunctionComponent<Props> = ({ title, description }) => {
  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
    </Helmet>
  );
};

export default SEO;
